// @flow

import React from "react";

const UnifizeLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="114"
    height="26"
    fill="none"
    viewBox="0 0 114 26"
  >
    <path
      fill="url(#a)"
      fillRule="evenodd"
      d="M1.863 6.789C.835 6.789 0 7.606 0 8.613v8.558c0 2.425 1.013 4.629 2.644 6.225a9.075 9.075 0 0 0 6.36 2.587c2.478 0 4.73-.99 6.36-2.587 1.632-1.596 2.644-3.8 2.644-6.225v-3.087c0-1.007-.835-1.823-1.864-1.823-1.028 0-1.863.816-1.863 1.823v3.087c0 1.418-.594 2.709-1.552 3.646a5.317 5.317 0 0 1-3.725 1.518 5.317 5.317 0 0 1-3.725-1.518 5.095 5.095 0 0 1-1.552-3.646v-7.05h.913c.937 0 1.703-.75 1.703-1.666 0-.917-.766-1.666-1.703-1.666H1.863z"
      clipRule="evenodd"
    />
    <path
      fill="url(#b)"
      fillRule="evenodd"
      d="M9.784 7.859c-1.63 1.596-2.643 3.8-2.643 6.225v3.086c0 1.008.834 1.824 1.863 1.824 1.03 0 1.864-.816 1.864-1.824v-3.086c0-1.418.594-2.71 1.551-3.646a5.319 5.319 0 0 1 3.726-1.519 5.32 5.32 0 0 1 3.726 1.518 5.097 5.097 0 0 1 1.551 3.647v7.05h-.914c-.936 0-1.702.75-1.702 1.666 0 .916.766 1.666 1.702 1.666h2.777c1.03 0 1.864-.817 1.864-1.824v-8.558c0-2.425-1.013-4.63-2.644-6.225a9.077 9.077 0 0 0-6.36-2.587c-2.478 0-4.73.99-6.36 2.587z"
      clipRule="evenodd"
    />
    <mask
      id="c"
      width="120"
      height="31"
      x="-3"
      y="-3"
      maskUnits="userSpaceOnUse"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M-2.244-2.344H116.48V27.58H-2.244V-2.344z"
        clipRule="evenodd"
      />
    </mask>
    <g fill="#292E34" fillRule="evenodd" clipRule="evenodd" mask="url(#c)">
      <path d="M43.47 22.76c-.714.18-1.642.365-2.785.554-1.142.19-2.397.285-3.763.285-1.285 0-2.361-.18-3.228-.54-.868-.359-1.56-.858-2.081-1.497-.52-.638-.893-1.402-1.117-2.291-.225-.888-.337-1.861-.337-2.92V7.576h3.703v8.206c0 1.677.25 2.875.75 3.594.5.719 1.371 1.078 2.616 1.078.448 0 .922-.02 1.423-.06.5-.04.872-.09 1.117-.15V7.577h3.702V22.76zM46.346 8.086c.713-.199 1.642-.39 2.784-.569 1.142-.18 2.407-.27 3.794-.27 1.306 0 2.397.176 3.275.525.876.35 1.575.838 2.096 1.467.52.63.887 1.388 1.101 2.276.214.89.321 1.862.321 2.92v8.805h-3.702v-8.235c0-.84-.056-1.553-.168-2.142-.113-.588-.296-1.068-.551-1.438a2.196 2.196 0 0 0-1.04-.808c-.44-.17-.975-.255-1.607-.255-.47 0-.959.03-1.468.09-.51.06-.888.11-1.133.15V23.24h-3.702V8.086zM62.441 23.24h3.702V7.577h-3.702V23.24zm3.427-18.628c.448-.399.673-.938.673-1.617 0-.699-.225-1.248-.673-1.647a2.316 2.316 0 0 0-1.592-.6c-.632 0-1.173.2-1.621.6-.45.4-.673.948-.673 1.647 0 .68.224 1.218.673 1.617.448.4.99.6 1.621.6.613 0 1.143-.2 1.592-.6zM85.084 23.24h-3.703V7.577h3.703V23.24zm.428-20.245c0 .68-.225 1.218-.673 1.617-.449.4-.979.6-1.591.6-.633 0-1.174-.2-1.622-.6-.449-.399-.673-.938-.673-1.617 0-.699.224-1.248.673-1.647.448-.4.99-.6 1.622-.6.612 0 1.142.2 1.591.6.448.4.673.948.673 1.647zM77.572.18C77.032.06 76.373 0 75.598 0c-2.223 0-3.876.57-4.957 1.707-1.082 1.138-1.621 2.725-1.621 4.762V23.24h3.702V10.602h5.875V7.577h-5.875V6.53c0-1.018.23-1.846.688-2.486.46-.639 1.3-.958 2.525-.958.469 0 .903.04 1.3.12.398.08.74.17 1.025.27l.582-2.936c-.306-.12-.73-.24-1.27-.36zM99.19 10.123c-.409.42-.944 1.008-1.607 1.767a94.268 94.268 0 0 0-2.127 2.53 110.38 110.38 0 0 0-2.28 2.905 58.4 58.4 0 0 0-2.065 2.89h8.262v3.026h-12.73v-2.247a28.433 28.433 0 0 1 1.683-2.605c.674-.938 1.367-1.882 2.081-2.83a83.637 83.637 0 0 1 2.127-2.71c.704-.86 1.331-1.608 1.882-2.247H87.04V7.577H99.19v2.546zM100.184 11.86c-.418 1.038-.627 2.246-.627 3.624 0 1.178.163 2.26.49 3.25a6.953 6.953 0 0 0 1.499 2.575c.673.729 1.53 1.298 2.57 1.707 1.041.409 2.265.614 3.672.614a14.5 14.5 0 0 0 1.622-.09c.53-.06 1.025-.135 1.484-.225.459-.09.867-.19 1.224-.3.357-.109.637-.213.842-.314l-.49-2.965c-.429.18-1.015.35-1.76.51-.744.16-1.565.24-2.463.24-1.53 0-2.698-.345-3.504-1.034-.805-.69-1.259-1.662-1.361-2.92h10.557c.019-.2.035-.424.046-.674.009-.25.015-.474.015-.674 0-2.655-.617-4.651-1.851-5.99-1.235-1.337-2.953-2.006-5.156-2.006-.939 0-1.857.175-2.754.524a6.907 6.907 0 0 0-2.387 1.557c-.694.69-1.25 1.553-1.668 2.59zm9.899.584c.142.45.214.923.214 1.422h-6.885c.062-.459.173-.908.337-1.347.163-.44.393-.829.689-1.168.295-.34.658-.614 1.086-.824.428-.21.928-.314 1.499-.314.551 0 1.025.095 1.423.284.398.19.735.45 1.01.779.275.33.484.719.627 1.168z" />
    </g>
    <defs>
      <linearGradient
        id="a"
        x1="-10.657"
        x2="23.823"
        y1="2.787"
        y2="-11.335"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#84CFF2" />
        <stop offset=".981" stopColor="#4681C2" />
        <stop offset="1" stopColor="#4681C2" />
      </linearGradient>
      <linearGradient
        id="b"
        x1="-8.921"
        x2="25.56"
        y1="6.362"
        y2="-7.76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#84CFF2" />
        <stop offset=".981" stopColor="#4681C2" />
        <stop offset="1" stopColor="#4681C2" />
      </linearGradient>
    </defs>
  </svg>
);

export default UnifizeLogo;
